import { render, staticRenderFns } from "./SaleReturnDetail.vue?vue&type=template&id=1952c273&"
import script from "./SaleReturnDetail.vue?vue&type=script&lang=js&"
export * from "./SaleReturnDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Ramon/PROYECTOS/JuanGabriel_POS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1952c273')) {
      api.createRecord('1952c273', component.options)
    } else {
      api.reload('1952c273', component.options)
    }
    module.hot.accept("./SaleReturnDetail.vue?vue&type=template&id=1952c273&", function () {
      api.rerender('1952c273', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/SaleReturnDetail.vue"
export default component.exports